import {
  DEFAULT_PARTICIPANTS_CATEGORY,
  PARTICIPANTS_CATEGORIES
} from 'constants/participants'
import {
  GetHasOnlyDefaultCategoryParticipant,
  GetHasUnassignedParticipants,
  GetNewParticipantsSelection
} from './types/getNewParticipantsSelection.types'
import {
  cloneParticipantsObject,
  getIsParticipantsNumberMatchingConf,
  getParticipantsNumber,
  getParticipantsNumberInCategory,
  getParticipantsWithBirthdateList,
  getRulesMaxValuesList,
  reassignParticipants
} from './'

const getHasOnlyDefaultCategoryParticipants: GetHasOnlyDefaultCategoryParticipant = (
  participants
) => (
  PARTICIPANTS_CATEGORIES.every(category => {
    if (
      category !== DEFAULT_PARTICIPANTS_CATEGORY &&
      getParticipantsNumberInCategory(participants, category) !== 0
    ) {
      return false
    }
    return true
  })
)

const getHasUnassignedParticipants: GetHasUnassignedParticipants = (
  unassignedParticipants
) => (
  Boolean(unassignedParticipants.length)
)

export const getNewParticipantsSelection: GetNewParticipantsSelection = (
  participants,
  { conf, rules, ...minMaxPax },
  { checkoutDate, shouldUpdateSelection } = {}
) => {
  const categories = PARTICIPANTS_CATEGORIES
  const participantsNumber = getParticipantsNumber(participants)
  const isMinMaxConf = Boolean(participantsNumber > 0 && minMaxPax.minPax && minMaxPax.maxPax && minMaxPax.minPax === minMaxPax.maxPax)
  const isParticipantsNumberMatchingConf = getIsParticipantsNumberMatchingConf(participantsNumber, minMaxPax)

  if ((isMinMaxConf && participantsNumber <= minMaxPax.maxPax!) || isParticipantsNumberMatchingConf) {
    const unassignedParticipants = getParticipantsWithBirthdateList(participants)
    const hasUnassignedParticipants = getHasUnassignedParticipants(unassignedParticipants)
    const maxValuesPerCategories = getRulesMaxValuesList(rules)

    let scope = rules
    let participantsTotal = getParticipantsNumber(participants)

    if (shouldUpdateSelection && !hasUnassignedParticipants) {
      return cloneParticipantsObject(participants)
    }

    if (hasUnassignedParticipants) {
      try {
        const newParticipantsSelection = reassignParticipants(conf, participants, unassignedParticipants, { checkoutDate, shouldUpdateSelection })

        if (isMinMaxConf) {
          for (let i = 0; i < categories.length; i++) {
            const category = categories[i]
            const categoryParticipantsNumber = getParticipantsNumberInCategory(newParticipantsSelection, category)

            if (categoryParticipantsNumber <= maxValuesPerCategories[i]) {
              participantsTotal -= categoryParticipantsNumber

              if (participantsTotal === 0) {
                return newParticipantsSelection
              }
            } else { break }
          }
        } else {
          for (let i = 0; i < categories.length; i++) {
            const category = categories[i]
            const participantsNumber = newParticipantsSelection[category].number

            if (Array.isArray(scope) && scope.includes(participantsNumber) && ((participantsTotal - participantsNumber) === 0)) {
              return newParticipantsSelection
            } else if (!Array.isArray(scope) && scope[participantsNumber]) {
              participantsTotal -= participantsNumber
              scope = scope[participantsNumber]
            } else { break }
          }
        }
      } catch (e) { return participants }
    } else if (Array.isArray(rules) && rules.includes(participantsNumber) && getHasOnlyDefaultCategoryParticipants(participants)) {
      if (isMinMaxConf) {
        for (let i = 0; i < categories.length; i++) {
          const category = categories[i]
          const categoryParticipantsNumber = getParticipantsNumberInCategory(participants, category)

          if (categoryParticipantsNumber <= maxValuesPerCategories[i]) {
            participantsTotal -= categoryParticipantsNumber

            if (participantsTotal === 0) {
              return cloneParticipantsObject(participants)
            }
          } else { break }
        }
      } else {
        for (let i = 0; i < categories.length; i++) {
          const category = categories[i]
          const participantsNumber = participants[category].number

          if (Array.isArray(scope) && scope.includes(participantsNumber) && ((participantsTotal - participantsNumber) === 0)) {
            return cloneParticipantsObject(participants)
          } else if (!Array.isArray(scope) && scope[participantsNumber]) {
            participantsTotal -= participantsNumber
            scope = scope[participantsNumber]
          } else { break }
        }
      }
    }
  } else if (minMaxPax.minPax === 1 && minMaxPax.maxPax === 1) {
    return {
      adults: {
        birthdates: [],
        number: 1
      },
      babies: {
        birthdates: [],
        number: 0
      },
      children: {
        birthdates: [],
        number: 0
      }
    }
  }
  return participants
}
